const publish = (name, payload) => {
  try { window.Shopify?.analytics?.publish?.(name, payload); } catch { /* Analytics must not block navigation. */ }
};

const seen = new WeakSet();
const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (!entry.isIntersecting || seen.has(entry.target)) continue;
    seen.add(entry.target);
    const item = entry.target;
    const surface = item.closest('[data-tbwl-discovery]');
    const suffix = surface?.dataset.tbwlDiscovery === 'siblings' ? 'product_sibling' : 'intent_recommendation';
    publish(`tbwl_${suffix}_impression`, {
      source_sku: surface?.dataset.sourceSku,
      target_sku: item.dataset.targetSku,
      relationship: item.dataset.relationship,
      source_availability: surface?.dataset.sourceAvailability,
    });
    observer.unobserve(item);
  }
}, { threshold: 0.5 });

for (const item of document.querySelectorAll('[data-tbwl-discovery-item]')) {
  observer.observe(item);
  item.addEventListener('click', (event) => {
    if (!event.target.closest('a[href]')) return;
    const surface = item.closest('[data-tbwl-discovery]');
    const suffix = surface?.dataset.tbwlDiscovery === 'siblings' ? 'product_sibling' : 'intent_recommendation';
    publish(`tbwl_${suffix}_click`, {
      source_sku: surface?.dataset.sourceSku,
      target_sku: item.dataset.targetSku,
      relationship: item.dataset.relationship,
      source_availability: surface?.dataset.sourceAvailability,
    });
  });
}
